export class EmailModel {

    public id: number;
    public user: string;
    public avatar: string;
    public type: string;
    public createdAt: string;
    public client: string;
    public subject: string;
    public text: string;
    public toEmail: string;
    public fromEmail: string;
    public attachments: Array<Attachment>;


    constructor(obj?: any) {
        this.id          = obj && obj.id                                    || null;
        this.user        = obj && obj.user                                  || '';
        this.avatar      = obj && obj.avatar                                || '';
        this.type        = obj && obj.type                                  || '';
        this.createdAt   = obj && obj.createdAt                             || '';
        this.client      = obj && obj.client                                || '';
        this.subject     = obj && obj.subject                               || '';
        this.text        = obj && obj.text                                  || '';
        this.toEmail     = obj && obj.toEmail                               || '';
        this.fromEmail   = obj && obj.fromEmail                             || '';
        this.attachments = obj && obj.attachments as Array<Attachment>      || null;

    }
}

export class Attachment {
    public id: number;
    public email_id: number;
    public title: string;
    public url: string;

    constructor(obj?: any) {
        this.id         = obj && obj.id         || null;
        this.email_id   = obj && obj.email_id   || null;
        this.title      = obj && obj.title      || '';
        this.url        = obj && obj.url        || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/email.model.ts